"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Card_vue_1 = __importDefault(require("@/client/components/card/Card.vue"));
const CardOrderStorage_1 = require("@/client/utils/CardOrderStorage");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
exports.default = (0, vue_1.defineComponent)({
    name: 'SortableCards',
    components: {
        Card: Card_vue_1.default,
    },
    props: {
        cards: {
            type: Array,
            required: true,
        },
        playerId: {
            type: String,
            required: true,
        },
    },
    data() {
        const cache = CardOrderStorage_1.CardOrderStorage.getCardOrder(this.playerId);
        const cardOrder = {};
        const keys = Object.keys(cache);
        let max = 0;
        for (const key of keys) {
            if (this.cards.find((card) => card.name === key) !== undefined) {
                cardOrder[key] = cache[key];
                max = Math.max(max, cache[key]);
            }
        }
        max++;
        for (const card of this.cards) {
            if (cardOrder[card.name] === undefined) {
                cardOrder[card.name] = max++;
            }
        }
        return {
            showReorder: false,
            cardOrder: cardOrder,
            dragCard: undefined,
        };
    },
    methods: {
        getSortedCards() {
            return CardOrderStorage_1.CardOrderStorage.getOrdered(this.cardOrder, this.cards);
        },
        onDragStart(source) {
            this.dragCard = source;
        },
        onDragEnd() {
            this.dragCard = undefined;
        },
        onDragOver(source) {
            if (this.dragCard === undefined || source === this.dragCard) {
                return;
            }
            if (source === 'end') {
                let max = 0;
                const keys = Object.keys(this.cardOrder);
                for (const key of keys) {
                    max = Math.max(max, this.cardOrder[key]);
                }
                this.cardOrder[this.dragCard] = max + 1;
            }
            else {
                const temp = this.cardOrder[source];
                const keys = Object.keys(this.cardOrder);
                for (const key of keys) {
                    if (this.cardOrder[key] >= temp) {
                        this.cardOrder[key]++;
                    }
                }
                this.cardOrder[this.dragCard] = temp;
            }
            CardOrderStorage_1.CardOrderStorage.updateCardOrder(this.playerId, this.cardOrder);
        },
        doNotDragAndDropOnReorder() {
            return this.showReorder ? 'do-not-drag-and-drop' : '';
        },
        clickMethod(e) {
            if (!this.showReorder)
                return;
            const target = e.currentTarget;
            if (!target)
                return;
            if (target.matches('.sortable-cards *')) {
                const rect = target.getBoundingClientRect();
                const x = (e.clientX - rect.left) / rect.width;
                const direction = x <= 0.25 ? -1.5 : x >= 0.75 ? 1.5 : null;
                if (direction) {
                    const cardTitle = target.querySelector('.card-title');
                    if (cardTitle) {
                        const textContent = cardTitle.textContent;
                        if (textContent) {
                            const thisCard = textContent.trim();
                            this.cardOrder[thisCard] += direction;
                            Object.entries(this.cardOrder)
                                .sort((a, b) => a[1] - b[1])
                                .forEach((entry, i) => {
                                this.cardOrder[entry[0]] = i + 1;
                            });
                            CardOrderStorage_1.CardOrderStorage.updateCardOrder(this.playerId, this.cardOrder);
                        }
                    }
                }
            }
        },
        experimentalUI() {
            return (0, PreferencesManager_1.getPreferences)().experimental_ui;
        },
    },
});
